shadow$provide[185] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Factory:{enumerable:true, get:function() {
  return require$_DOT__SLASH_factory_DOT_js.OverlayFactory;
}}});
var require$_DOT__SLASH_factory_DOT_js = require("./factory.js");
var require$_DOT__SLASH_classes_DOT_js = require("./classes.js");
var require$_DOT__SLASH_overlay_DOT_js = require("./overlay.js");
require.exportCopy(module, require$_DOT__SLASH_classes_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_overlay_DOT_js);

};